import { render, staticRenderFns } from "./rubric_fullscreen_modal.vue?vue&type=template&id=1f1a0487&scoped=true&"
import script from "./rubric_fullscreen_modal.vue?vue&type=script&lang=js&"
export * from "./rubric_fullscreen_modal.vue?vue&type=script&lang=js&"
import style0 from "./rubric_fullscreen_modal.vue?vue&type=style&index=0&id=1f1a0487&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1a0487",
  null
  
)

export default component.exports